<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile
    },
    created() {
        this.$store.commit('getTaiwan', 'DR')
        this.$store.dispatch('getBannerZt', '零售')
        this.$store.dispatch('getBannerArticle', '零售')
        this.$store.commit('getSubmit', '零售')
        this.$store.commit('dataColor', {
            bar0: '#02973a',  
            bar1: '#04a23f',
            line0: '#ff6a04',
            line1: '#fbae08'
        })
    },
}
</script>

<style>
/* #app .nav ul li:last-child {
    display: none;
} */

#app .right-box .form .btn:hover {
    color: #fff;
    background-color: #02973a;
    border-color: #02973a;
}

.company h2::before,
.content-right .platform li:hover,
.move-searchBox,
.report-con .report-title p,
.report-list li a:hover .report-con,
.tsb a:hover span {
    background: #02973a;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    color: #02973a !important;
    background: #eee !important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover span {
    color: #02973a !important;
}

.content-left .title {
    border-left: 5px solid #02973a;
}
.content-left .title h2 span {
    color: #02973a;
    padding: 0 10px;
}

.content-right .right-title a:hover,
.company-title a:hover,
#app .right-box .form .btn,
.text a:hover span,
.content-left .more a,
.project a:hover p,
.report-list li a:hover .report-title p,
.tsb a:hover p,
.mobile-bottom .current,
.mobile-top .current2,
.mobile-submit i,
.backtop:hover,
.code-box:hover {
    color: #02973a;
}

@media(max-width: 868px) {
  .banner-right .banner-right-m p {
    background: #02973a;
  }
}
</style>